import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSystemStore = defineStore('system', () => {
  const maintenanceMode = ref(false);
  const maintenanceMessage = ref('');

  function activateMaintenance(msg = 'energielenker connect is undergoing maintenance, we’ll be back soon') {
    maintenanceMode.value = true;
    maintenanceMessage.value = msg;
  }

  function deactivateMaintenance() {
    maintenanceMode.value = false;
    maintenanceMessage.value = '';
  }

  return { maintenanceMode, maintenanceMessage, activateMaintenance, deactivateMaintenance };
});